/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const MINUS_VIEWBOX_W = 16;
const MINUS_VIEWBOX_H = 2;

const MINUS_PATH =
  'M15 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H15C15.2652 2 15.5196 1.89464 15.7071 1.70711C15.8946 1.51957 16 1.26522 16 1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Minus bar (16×2 viewBox). `size` sets rendered width; height scales to aspect ratio.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const MinusIcon = ({
  size = 16,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = (size * MINUS_VIEWBOX_H) / MINUS_VIEWBOX_W;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${MINUS_VIEWBOX_W} ${MINUS_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={MINUS_PATH} fill={fill} />
    </svg>
  );
};

MinusIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
};

export { MinusIcon };
export default MinusIcon;
